import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import XGSFormInput from "../../../../ui-components/form/input/xgsFormInput";
import XGSFormTextarea from "../../../../ui-components/form/textarea/xgsFormTextarea";
import { LabelModes } from "../../../../ui-components/molecules/labeled-inputs/labeledInput";
import { BolDocument } from "../../../../app/data/pickup-requests/bolModels";
import { BolReviewFormValues } from "../utils/bolReviewMappers";
import BolFieldWithAi from "./bolFieldWithAi";
import BolPartyFields from "./bolPartyFields";
import BolPickupWindowSection from "./bolPickupWindowSection";
import BolCommodityRows from "./bolCommodityRows";

export interface BolCapturedBolReviewFieldsProps {
  bolDoc: BolDocument;
  onFormSync: (values: BolReviewFormValues) => void;
}

const BolCapturedBolReviewFields: React.FC<BolCapturedBolReviewFieldsProps> = ({
  bolDoc,
  onFormSync,
}) => {
  const { values } = useFormikContext<BolReviewFormValues>();

  useEffect(() => {
    onFormSync(values);
  }, [values, onFormSync]);

  return (
    <>
      <div className="xgs-captured-bol__row xgs-captured-bol__row--cols-3">
        <BolFieldWithAi label="BOL Number" field={bolDoc.bol} required>
          <XGSFormInput
            type="text"
            name="bolNumber"
            label=""
            labelMode={LabelModes.column}
            required
            requiredAsteriskDisabled
            placeholder="Enter BOL Number"
          />
        </BolFieldWithAi>
        <BolFieldWithAi label="PO Number" field={bolDoc.purchaseOrder}>
          <XGSFormInput type="text" name="poNumber" label="" labelMode={LabelModes.column} />
        </BolFieldWithAi>
        <BolFieldWithAi label="Additional Reference" field={bolDoc.orderDescription}>
          <XGSFormInput type="text" name="additionalReference" label="" labelMode={LabelModes.column} />
        </BolFieldWithAi>
      </div>

      <BolPartyFields bolDoc={bolDoc} />
      <BolPickupWindowSection bolDoc={bolDoc} />
      <BolCommodityRows />

      <div className="xgs-captured-bol__instructions">
        <BolFieldWithAi label="Special Instructions" field={bolDoc.generalNotes}>
          <XGSFormTextarea
            name="specialInstructions"
            label=""
            rows={4}
            counter={150}
            labelMode={LabelModes.column}
            placeholder="Enter any special handling instructions or delivery notes..."
          />
        </BolFieldWithAi>
      </div>
    </>
  );
};

export default BolCapturedBolReviewFields;
